import { render, staticRenderFns } from "./SiteBlockRenderer.vue?vue&type=template&id=ebdcceb0"
import script from "./SiteBlockRenderer.vue?vue&type=script&lang=js"
export * from "./SiteBlockRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports